var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleGreenTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 21,
    viewBox: "0 0 39 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.2128L20.8438 18L37 2",
    stroke: "#27D639",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.2128L7.84375 18L24 2",
    stroke: "#27D639",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleGreenTick);
export default __webpack_public_path__ + "static/media/doubleGreenTick.cd5f07113c07d6de166362f0bb8b7214.svg";
export { ForwardRef as ReactComponent };